import httpRequest from 'httpRequest'
import {
    CustomerDisplaySettingContract,
    CustomerDisplaySettingLookupContract,
} from 'models'

const ROUTE = '/location/customer-display-settings'

const customerDisplaySettingService = {
    getCustomerDisplaySettings: () =>
        httpRequest.get<CustomerDisplaySettingLookupContract[]>(ROUTE),
    getCustomerDisplaySetting: (settingId: string) =>
        httpRequest.get<CustomerDisplaySettingContract>(
            `${ROUTE}/${settingId}`,
        ),
    getCustomerDisplaySettingByClientId: (clientId: string) =>
        httpRequest.get<CustomerDisplaySettingContract>(
            `${ROUTE}/show/${clientId}`,
        ),
    updateCustomerDisplaySetting: (
        settingId: string,
        contract: CustomerDisplaySettingContract,
    ) => httpRequest.put(`${ROUTE}/${settingId}`, contract),
    createCustomerDisplaySetting: (contract: CustomerDisplaySettingContract) =>
        httpRequest.post(ROUTE, contract),
    deleteCustomerDisplaySetting: (customerFacingDisplaySettingIDs: string[]) =>
        httpRequest.delete(ROUTE, {
            params: {
                customerFacingDisplaySettingIDs,
            },
        }),
}

export default customerDisplaySettingService
